import { render, staticRenderFns } from "./ChipComponent.vue?vue&type=template&id=3e98b122"
import script from "./ChipComponent.vue?vue&type=script&lang=js"
export * from "./ChipComponent.vue?vue&type=script&lang=js"
import style0 from "./ChipComponent.vue?vue&type=style&index=0&id=3e98b122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
